import i18next from "src/i18n/config";
import RouteService from "src/services/routeService";
import { invalidateOnSuccess, transformErrorResponse } from "src/store/helpers";
import { BasicApiResponse, PaginatedResponse } from "src/types";

import { toBackendPageIndex } from "@shared/table/Tanstack.utils";

import { AdminBuilder } from "./tags";

export type GetAccountsParams = {
    HasRoles?: boolean;
    ExcludeDeleted?: boolean;
    SortCriteria?: string;
    SortDirection?: 0 | 1 | -1;
    PageIndex?: number;
    PageSize?: number;
};

type DeleteAccountParams = {
    id: string;
    fullDeletion: boolean;
    sendNotification: boolean;
};

const accounts = (builder: AdminBuilder) => ({
    getAccounts: builder.query<PaginatedResponse<API.Account>, GetAccountsParams>({
        providesTags: ["Accounts"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        query: async (params) => {
            const base = await RouteService.getAdminAccountsRoute();
            return {
                url: `${base}all`,
                params: { ...params, PageIndex: toBackendPageIndex(params.PageIndex) },
            };
        },
    }),

    deleteAccount: builder.mutation<BasicApiResponse, DeleteAccountParams>({
        invalidatesTags: invalidateOnSuccess("Accounts"),
        transformErrorResponse: (err) =>
            transformErrorResponse(err, i18next.t("pages:adminAccountsPage.toast.accountDeletedError")),
        query: async ({ id, ...params }) => {
            const base = await RouteService.getAdminAccountsRoute();
            return { url: `${base}${id}`, method: "DELETE", params };
        },
    }),
});

export default accounts;
